import { useEffect, useState } from "react";

/**
 * A ~30-line router, deliberately.
 *
 * This app has four flat routes and no nested layouts, loaders, or route-level
 * code splitting. A routing library would add a dependency and a concept count
 * out of proportion to that. Revisit if nested routes or per-route data loading
 * ever appear.
 *
 * CloudFront is configured with an SPA fallback, so a deep link like
 * /contracts serves index.html and this resolves the path client-side.
 */
export function useRoute(): { path: string } {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    // navigate() dispatches this, since pushState alone fires no event.
    window.addEventListener("route", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      window.removeEventListener("route", onPop);
    };
  }, []);

  return { path };
}

export function navigate(to: string): void {
  if (to === window.location.pathname) return;
  window.history.pushState({}, "", to);
  window.dispatchEvent(new Event("route"));
}
